import IndustryChallengesI18n from "@/components/landing/shared/IndustryChallengesI18n";
import { ShoppingCart, Clock, RotateCcw, TrendingDown } from "lucide-react";
const HerausforderungenECommerceSection = () => <IndustryChallengesI18n translationPrefix="industryECommerce" icons={[ShoppingCart, Clock, RotateCcw, TrendingDown]} />;
export default HerausforderungenECommerceSection;
